export default __webpack_public_path__ + "static/media/notFound.3eb42a14.jpg";